import * as AT from "src/core/notifications/store/notifications.constants";
import { INotification } from "src/core/notifications/api/notifications.api";

export type NotificationActions =
  | ISetNotification
  | IPurgeNotifications
  | IToggleNotifications;

interface ISetNotification {
  type: AT.SET_NOTIFICATION;
  notification: INotification | null;
}

export const setNotification = (notification: INotification | null): ISetNotification => {
  return {
    type: AT.SET_NOTIFICATION,
    notification
  };
};

interface IPurgeNotifications {
  type: AT.PURGE_NOTIFICATIONS;
}

export const purgeNotifications = (): IPurgeNotifications => {
  return { type: AT.PURGE_NOTIFICATIONS };
};

interface IToggleNotifications {
  type: AT.SHOW_HIDE_NOTIFICATIONS;
  show?: boolean;
  notificationId?: number | null;
}

export const toggleNotifications = (show?: boolean, notificationId?: number | null): IToggleNotifications => {
  return {
    type: AT.SHOW_HIDE_NOTIFICATIONS,
    show,
    notificationId
  };
};
